import { render, staticRenderFns } from "./PgaSwitch.vue?vue&type=template&id=12cdee1e&scoped=true&"
import script from "./PgaSwitch.vue?vue&type=script&lang=ts&"
export * from "./PgaSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./PgaSwitch.vue?vue&type=style&index=0&id=12cdee1e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cdee1e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12cdee1e')) {
      api.createRecord('12cdee1e', component.options)
    } else {
      api.reload('12cdee1e', component.options)
    }
    module.hot.accept("./PgaSwitch.vue?vue&type=template&id=12cdee1e&scoped=true&", function () {
      api.rerender('12cdee1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaSwitch.vue"
export default component.exports